import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { humanCapabilityProducts } from '../../data/home';
import { fadeUp } from '../../utils/motion';
export function HomeEcosystem() {
  return <section className="bg-surface-bg py-20 lg:py-28" data-id="element-367" data-mp="2xelgpl7kwg6k">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-368" data-mp="32c3imrn6hv52">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-14" data-id="element-369" data-mp="32aamw7e3svbu">
          <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight" data-id="element-370" data-mp="24mid8dxv01nd">
            The SyNeural ecosystem
          </h2>
          <p className="lg:col-span-7 text-xl text-ink-dark leading-relaxed lg:pt-2" data-id="element-371" data-mp="2elrbvk3o64g2">
            Noetivra is where professionals do the work. It uses the Semantic
            Knowledge Platform for its approved knowledge, sources, and review
            history, and it can run Human Capability modules, including CJI and
            NCJI.
          </p>
        </motion.div>

        {/* Noetivra: the application layer */}
        <motion.div {...fadeUp} className="bg-navy-deep text-white rounded-lg p-8 lg:p-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16" data-id="element-372" data-mp="h4e77vv03gr3">
          <div className="lg:col-span-5" data-id="element-373" data-mp="7eb618dq6who">
            <p className="text-sm font-medium text-teal mb-2" data-id="element-374" data-mp="7d9vr64jae10">Professional application · Coming soon</p>
            <h3 className="font-heading font-bold text-3xl" data-id="element-375" data-mp="2efazyn0afe9">Noetivra</h3>
          </div>
          <div className="lg:col-span-7" data-id="element-376" data-mp="3uhze30abw6a8">
            <p className="text-white/80 leading-relaxed mb-6" data-id="element-377" data-mp="3pkg1s5x6y3kx">
              A modular intelligence system for assessments and professional
              review. Professionals prepare sessions, gather information,
              review findings, and record decisions in one workspace, with
              modules for capability development, hiring, clinical review, and
              research.
            </p>
            <a href="/noetivra" className="inline-flex items-center gap-1.5 text-sm font-semibold text-white hover:text-teal transition-colors duration-150 whitespace-nowrap" data-id="element-378" data-mp="1dv6qf2d8dox3">
              Explore Noetivra
              <ArrowRight size={14} aria-hidden="true" data-id="element-379" data-mp="3d4ge9uwfxjd3" />
            </a>
          </div>
        </motion.div>

        {/* What Noetivra draws on */}
        <motion.div {...fadeUp} className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-380" data-mp="33bsjf5p0tph0">
          <div className="bg-white border border-line rounded-lg p-8 lg:p-10 flex flex-col" data-id="element-381" data-mp="3r1mv3jxlt7zo">
            <p className="text-sm font-medium text-teal mb-2" data-id="element-382" data-mp="3w0ziq6wauj3b">Supplies Noetivra’s knowledge</p>
            <h3 className="font-heading font-bold text-2xl text-ink-dark mb-3" data-id="element-383" data-mp="3i1q9jr6igp8u">Semantic Knowledge Platform</h3>
            <p className="text-ink-muted leading-relaxed mb-8" data-id="element-384" data-mp="3m2iiskfduu54">
              A configurable system for structured content, shared concepts,
              connected evidence, knowledge graphs, semantic search, and
              AI-assisted research.
            </p>
            <a href="/semantic-knowledge" className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-teal transition-colors duration-150 whitespace-nowrap" data-id="element-385" data-mp="2aljxr3va0mxo">
              Explore the platform
              <ArrowRight size={14} aria-hidden="true" data-id="element-386" data-mp="2d21j9df8t598" />
            </a>
          </div>

          <div className="lg:col-span-2 bg-white border border-line rounded-lg p-8 lg:p-10 flex flex-col" data-id="element-387" data-mp="284rv013lazmz">
            <div className="flex flex-wrap items-baseline justify-between gap-4 mb-3" data-id="element-388" data-mp="1kee0m3xj8op8">
              <div data-id="element-389" data-mp="1fg451s7wbm33">
                <p className="text-sm font-medium text-teal mb-2" data-id="element-390" data-mp="1fgm9hc4pp6m3">Runs in Noetivra as modules</p>
                <h3 className="font-heading font-bold text-2xl text-ink-dark" data-id="element-391" data-mp="1u50adhikil00">Human Capability Platform</h3>
              </div>
              <a href="/human-capability" className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-teal transition-colors duration-150 whitespace-nowrap" data-id="element-392" data-mp="11nej1nsdah5z">
                Platform overview
                <ArrowRight size={14} aria-hidden="true" data-id="element-393" data-mp="3w3vk3d42l62u" />
              </a>
            </div>
            <p className="text-ink-muted leading-relaxed max-w-2xl mb-8" data-id="element-394" data-mp="3z1hriy5s0yn">
              A framework and services for assessing and developing reasoning,
              civic judgment, resilience to manipulation, and leadership
              readiness.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-0 md:divide-x divide-line border-t border-line pt-8 mt-auto" data-id="element-395" data-mp="io7ff2hclj4f">
              {humanCapabilityProducts.map((product, index) => <div key={product.acronym} className={`flex flex-col ${index === 0 ? 'md:pr-8' : 'md:pl-8'}`} data-id="element-396" data-mp="rnujxx5dj51p" data-mpi={index}>
                  <p className="font-heading font-extrabold text-2xl text-navy" data-id="element-397" data-mp="wm4eq6n6s3ms">{product.acronym}</p>
                  <p className="text-sm font-medium text-ink-dark mt-1 mb-3" data-id="element-398" data-mp="2tgime4a71ogf">{product.name}</p>
                  <p className="text-ink-muted leading-relaxed mb-5" data-id="element-399" data-mp="2yflhavwgmeao">{product.body}</p>
                  <a href={product.link} className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-teal transition-colors duration-150" data-id="element-400" data-mp="2qvax8zaunv4f">
                    Explore {product.acronym}
                    <ArrowRight size={14} aria-hidden="true" data-id="element-401" data-mp="2c6etvfjqn6a5" />
                  </a>
                </div>)}
            </div>
          </div>
        </motion.div>

        <motion.p {...fadeUp} className="mt-14 text-2xl text-ink-dark leading-relaxed max-w-4xl" data-id="element-402" data-mp="39rsufw8gwn82">
          Together, these efforts support a larger goal: people who can reason
          well, knowledge that can be examined and connected, and institutions
          equipped to make responsible decisions.
        </motion.p>
      </div>
    </section>;
}